import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Checkbox from '@mui/material/Checkbox';
import ImageIcon from '@mui/icons-material/Image';
import { imageShape } from '../shapes/ImageShapes';

const ImageCheckList = ({ images, onCheckboxChange = () => {}, checkedImagesNames = {} }) => {
  return (
    <List dense disablePadding>
      {images.map(({ name }, index) => (
        <ListItem key={name + index} className="glint-hover-lift">
          <ListItemIcon>
            <ImageIcon />
          </ListItemIcon>
          <ListItemText primary={name} />
          <ListItemSecondaryAction>
            <Checkbox
              onChange={() => onCheckboxChange(name)}
              checked={name in checkedImagesNames}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

ImageCheckList.propTypes = {
  images: PropTypes.arrayOf(imageShape).isRequired,
  checkedImagesNames: PropTypes.object,
  onCheckboxChange: PropTypes.func,
};

export default ImageCheckList;
